/**
 * Created by RSchweber-Koren on 5/12/2017.
 */

class SubscriptionWorkflowCancelledError extends Error {
    constructor({userCancelled = true}) {
        super("Workflow was cancelled");
        this.name = "SubscriptionWorkflowCancelledError";
        this.wasUserCancelled = userCancelled;
    }
}

export default SubscriptionWorkflowCancelledError;


//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/SubscriptionWorkflowCancelledError.js
// module id = k3ZK
// module chunks = 1